import { createAction } from '@reduxjs/toolkit';
import { SET_ACTIVE_BROKER } from 'types/activeBroker';

export const setActiveBroker = createAction<string | undefined>(
  SET_ACTIVE_BROKER,
);
